module.exports = __webpack_public_path__ + "static/fonts/miller-display-roman.c950171.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/miller-display-roman.otf
// module id = 1194
// module chunks = 0